import type { ReactNode } from 'react'

import Icon, { type IconPropsType } from '@/legacy-src/components/icons/Icon'

import { Text } from '@/src/domains/design-system/components/Text'

export interface ClientBookingAvailableSlotRebookItemProps {
  title: string
  icon: IconPropsType['icon']
  children: ReactNode
}

export const ClientBookingAvailableSlotRebookItem = ({
  title,
  icon,
  children,
}: ClientBookingAvailableSlotRebookItemProps) => (
  <div className="flex items-center gap-3">
    <dt className="shrink-0">
      <Icon icon={icon} size={24} aria-label={title} />
    </dt>
    <Text element="dd" className="flex items-center" variant="lg">
      <span>{children}</span>
    </Text>
  </div>
)
